import { t } from '../../app/i18n';

export default {
  ADMINISTRATOR: 'ADMINISTRATOR',
  OPERATOR: 'OPERATOR',
  CALL_CENTRUM: 'CALL_CENTRUM',
  CREDITOR: 'CREDITOR',
  DEBTOR: 'DEBTOR',
  EXECUTOR: 'EXECUTOR',
};

export const adminRolesTranslation = {
  ADMINISTRATOR: t('Administrátor'),
  OPERATOR: t('Operátor'),
  CALL_CENTRUM: t('Pracovník call centra'),
}

export const translation = {
  ...adminRolesTranslation,
  CREDITOR: t('Investor'),
  DEBTOR: t('Dlžník'),
  EXECUTOR: t('Exekútor'),
};



// WEBPACK FOOTER //
// ./src/common/enums/accountRoles.js